import React from "react";
import styles from "./FinanceDisclaimerModal.module.scss";
import table from "../../../../../../shared-components/css-modules/toyota/molecules/Table.module.scss";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import type { ModalViewType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import type { FinanceDisclaimerModalType } from "../../../../../utils/modalConstants";
import SidePanel from "../../../../../../shared-components/css-modules/toyota/organisms/SidePanel";
import { useFinanceModalDisclaimers } from "../../../../../hooks/useDisclaimers";
import { IntegratedLegalBannerDisclaimer } from "../../../../../../../shared-components/toyota/IntegratedLegalBannerDisclaimer";

const FinanceDisclaimerModal = (props: ModalViewType<FinanceDisclaimerModalType>): JSX.Element | null => {
    const { show, close } = props;
    const { disclaimer, disclaimerTable, legalBannerDisclaimerData } = useFinanceModalDisclaimers();

    return (
        <SidePanel open={show} onRequestClose={close}>
            {!!disclaimer && !legalBannerDisclaimerData && (
                <div className={styles["modal-inner"]}>
                    <Text variant="apheleia-body" dangerouslySetInnerHTML={{ __html: disclaimer }} />

                    {disclaimerTable && (
                        <table className={table.wrapper}>
                            <tbody>
                                {disclaimerTable.map((config) => (
                                    <tr key={config.name}>
                                        <td>{config.name}</td>
                                        <td>
                                            <Text
                                                variant="apheleia-body"
                                                dangerouslySetInnerHTML={{ __html: config.value }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
            {legalBannerDisclaimerData && <IntegratedLegalBannerDisclaimer data={legalBannerDisclaimerData} />}
        </SidePanel>
    );
};

export default FinanceDisclaimerModal;
